import React, { useState, useEffect } from 'react';
import AcquisitionBasic from './AcquisitionBasic';
import moment from 'moment';
import {get_securities_acquisition_basic} from '../../services/common';

const SecuritiesAcquisition = ({ fumId }) => {
  const [transactions, setTransactions] = useState([]);
  const [acquisitions, setAcquisitions] = useState([]);
  const [basic, setBasic] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (fumId) {
      getSecuritiesAcquisitionBasic();
    }
  }, [fumId]);

  const getSecuritiesAcquisitionBasic = async () => {
    try {
      // const localData = JSON.parse(localStorage.getItem('caprock-local') || '{}'); // Fixed: Changed variable name
      // const userToken = localData['access-token']; // Fixed: Updated reference
      const userToken = localStorage.getItem('systemToken') || "";
      // You'll need to implement this API call in your services
      const response = await get_securities_acquisition_basic(userToken, fumId);
      
      if (response.success === 200) {
        setBasic(response.basic);
      }
      // Mock data for now
    } catch (error) {
      console.error('Error fetching securities acquisition data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-1 py-3 border-b">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  if (!fumId) {
    return null;
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <AcquisitionBasic fumId={fumId} basic={basic} />

      {/* Acquisitions Table */}
      <div className="w-full mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date/Acquisition</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount Invested</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount Returned</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valuation (AUM)</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Balance</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Profit</th>
              </tr>
            </thead>
            <tbody>
              {acquisitions.length > 0 ? (
                acquisitions.map((acq) => (
                  <tr key={acq.acq_id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {acq.acq_date} - {acq.acq_name}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof acq.acq_amount !== 'undefined' 
                        ? `${acq.currency_symbol} ${acq.acq_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof acq.acq_total_credit !== 'undefined' 
                        ? `${acq.currency_symbol} ${acq.acq_total_credit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof acq.acq_aum !== 'undefined' 
                        ? `${acq.currency_symbol} ${acq.acq_aum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof acq.acq_balance !== 'undefined' 
                        ? `${acq.currency_symbol} ${acq.acq_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof acq.acq_profit !== 'undefined' 
                        ? `${acq.currency_symbol} ${acq.acq_profit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Transactions Table */}
      <div className="w-full mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Credit</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Debit</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Balance</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length > 0 ? (
                transactions.map((trans) => (
                  <tr key={trans.trans_id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {trans.trans_date}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm" style={{ whiteSpace: 'normal' }}>
                      {trans.ref_description}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {trans.trans_type === 2 && typeof trans.trans_amount !== 'undefined' 
                        ? `${trans.currency_symbol} ${trans.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {trans.trans_type === 1 && typeof trans.trans_amount !== 'undefined' 
                        ? `${trans.currency_symbol} ${trans.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {typeof trans.trans_balance !== 'undefined' 
                        ? `${trans.currency_symbol} ${trans.trans_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : ''}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SecuritiesAcquisition;
